//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IBasicCuralateSession } from 'app/basic-session/ICuralateSession';

/**
 * Add session data for compiile-time constants, for backwards compatibility.
 * @param session the crl8.session object
 */
export default function shimCuralateEnvSessionVars<
  T extends IBasicCuralateSession,
>(session: T): T {
  return {
    ...session,
    baseUrls: {
      ...(session.baseUrls || {}),
      affable_gateway: CURALATE_ENV.AFFABLE_GATEWAY_URL,
      agent_gateway: CURALATE_ENV.AGENT_GATEWAY_URL,
      bazaarvoice_portal: CURALATE_ENV.BV_PORTAL,
      creators_portal_app: CURALATE_ENV.CREATORS_PORTAL_APP_URL,
      custom_reporting_gateway: CURALATE_ENV.CUSTOM_REPORTING_GATEWAY_URL,
      experience_gateway: CURALATE_ENV.EXPERIENCE_GATEWAY_URL,
      facebook_gateway: CURALATE_ENV.FACEBOOK_GATEWAY_URL,
      feed_gateway: CURALATE_ENV.FEED_GATEWAY_URL,
      image_insights_gateway: CURALATE_ENV.IMAGE_INSIGHTS_GATEWAY_URL,
      influencers_gateway: CURALATE_ENV.INFLUENCERS_GATEWAY_URL,
      instagram_dashboard_gateway: CURALATE_ENV.INSTAGRAM_DASHBOARD_GATEWAY_URL,
      ipt_gateway: CURALATE_ENV.IPT_GATEWAY_URL,
      like2buy_gateway: CURALATE_ENV.LIKE2BUY_GATEWAY_URL,
      media_api: CURALATE_ENV.MEDIA_API_URL,
      meds: CURALATE_ENV.MEDS_URL,
      metrics_gateway: CURALATE_ENV.METRICS_GATEWAY_URL,
      moderation_gateway: CURALATE_ENV.MODERATION_GATEWAY_URL,
      ops_web: CURALATE_ENV.OPS_WEB_URL,
      pinterest_dashboard_gateway: CURALATE_ENV.PINTEREST_DASHBOARD_GATEWAY_URL,
      reveal_v1: CURALATE_ENV.REVEAL_V1_URL,
      reveal_v2: CURALATE_ENV.REVEAL_V2_URL,
      sampling_gateway: CURALATE_ENV.SAMPLING_GATEWAY_URL,
      screen_capture: CURALATE_ENV.SCREEN_CAPTURE_URL,
      social_conversations_gateway:
        CURALATE_ENV.SOCIAL_CONVERSATIONS_GATEWAY_URL,
      social_listening_gateway: CURALATE_ENV.SOCIAL_LISTENING_GATEWAY_URL,
      syndication_gateway: CURALATE_ENV.SYNDICATION_GATEWAY_URL,
      tiktok_gateway: CURALATE_ENV.TIKTOK_GATEWAY_URL,
      twitter_gateway: CURALATE_ENV.TWITTER_GATEWAY_URL,
      universal_scheduling_gateway:
        CURALATE_ENV.UNIVERSAL_SCHEDULING_GATEWAY_URL,
      user_messaging_gateway: CURALATE_ENV.USER_MESSAGING_GATEWAY_URL,
      walmart_gateway: CURALATE_ENV.WALMART_GATEWAY_URL,
      web_analytics_configuration_gateway:
        CURALATE_ENV.WEB_ANALYTICS_CONFIGURATION_GATEWAY_URL,
      web_gateway: CURALATE_ENV.WEB_GATEWAY_URL,
      youtube_gateway: CURALATE_ENV.YOUTUBE_GATEWAY_URL,
    },
  };
}
